import React from 'react';
import { DriverReviewLightBoxStore } from '../../_flux/stores/driver_review_light_box_store';
import { DriverReviewLightBox } from '../../_flux/components/driver_review_light_box/driver_review_light_box';
import { hideAction } from '../../_flux/actions/driver_review_light_box_actions';
import LightboxStore from '../../_flux/stores/lightbox_store';
import { close } from '../../_modules/google_analytics/driver_review_light_box';
import { handleView } from '../handle_view';

const stores = {
    driverReviewLightBox: DriverReviewLightBoxStore,
    lightBox: LightboxStore,
};

function render(
    {
        driverReviewLightBox,
        lightBox,
    },
) {
    const { visible } = driverReviewLightBox;
    const LightBoxVisible = lightBox.visible;
    
    return (
        <DriverReviewLightBox
            visible={visible}
            data={driverReviewLightBox.obj}
            LightBoxVisible={LightBoxVisible}
            onClose={onClose}
        />
    );
}

const getOptions = options => ({
    ...options,
});

export const init = (container, options) =>
    handleView(stores, render, getOptions(options), container);

export const onClose = () => {
    hideAction();
    close();
};